import { createContext } from 'react';

const PopoverContext = createContext({
  isOpen: false,
  open: () => void 0,
  close: () => void 0,
  getTriggerProps: () => void 0,
  getPopoverProps: () => void 0,
  rest: {}
});

export { PopoverContext };
//# sourceMappingURL=PopoverContext.es.js.map
